const globalOption = {
    attribute: {
        // [0: 加载时, 1: 显示时]
        globalDataReload: [0]
    }
}

/**
 * 校验是否是对象
 * @param {*} item 
 * @returns 
 */
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}
/**
 * @title 合并对象
 * @param {*} target 
 * @param {*} source 
 * @returns 
 */
function deepMerge(target, source) {
    let output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, { [key]: source[key] });
                else
                    output[key] = deepMerge(target[key], source[key]);
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
}

/**
 * @title 批量设置option字段
 * @param {*} allOption 
 * @returns 
 */
export function globalAllHandler(allOption) {
    for (let i = 0; i < allOption.length; i++) {
        const children = allOption[i].children;
        for (let j = 0; j < children.length; j++) {
            const item = children[j];
            item.option = deepMerge(item.option, globalOption)
        }

    }
    return allOption
}


/**
 * @title 设置已配置的组件新字段
 * @param {*} components 
 * @returns 
 */
export function setGlobalComponentField(components) {
    for (let i = 0; i < components.length; i++) {
        const item = components[i];
        const { globalDataReload } = item.cptOption.attribute
        if (!globalDataReload) {
            // 设置组件刷新数据方式
            item.cptOption.attribute['globalDataReload'] = globalOption.attribute['globalDataReload']
        }
    }

    return components
}

export function setGlobalAttr(list = []) {
    list.forEach(item => {
        item.children.forEach(c=>{
            const { globalDataReload } = c.option.attribute
            if (!globalDataReload) {
                c.option.attribute.globalDataReload = globalOption.attribute.globalDataReload
            }
        })
    })
}
